export const userData = {
    app_name: "Ortho Clinical Diagnostics",
    user_name: "",
    account_name: "",
    notification: [{
        count: 6,
        message: ""
    }],
    user_avatar: ""
}